import { o365ApiConstants, o365Fields } from 'client/util/Constants/DirectoryConstants';

const { givenName, surname, userPrincipalName } = o365Fields;

export default {
  getO365ApiHeaders() {
    const { consistencyLevel, eventual } = o365ApiConstants;
    return { [consistencyLevel]: eventual };
  },

  getO365ApiOrderByStatement() {
    return `${userPrincipalName}`;
  },

  getO365ApiSearchParams(searchTerm) {
    if (!searchTerm) {
      return {};
    }
    return {
      count: true,
      orderby: this.getO365ApiOrderByStatement(),
      search: this.getO365ApiSearchStatement(searchTerm),
    };
  },

  getO365ApiSearchStatement(searchTerm) {
    return `"${userPrincipalName}:${searchTerm}" OR "${givenName}:${searchTerm}"  OR "${surname}:${searchTerm}"`;
  },

};
